/* eslint-disable simple-import-sort/imports */

import React, { useEffect, useRef } from 'react';

import Container from 'components/Container';

import {
  SectionVideo,
  VideoContainer,
  VideoDescription,
  VideoWrapper,
} from './styles';

const Video = () => {
  const iframeRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (iframeRef.current) {
        // Disable pointer events during scroll
        iframeRef.current.style.pointerEvents = 'none';

        // Clear existing timeout
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }

        // Re-enable pointer events after scroll stops
        scrollTimeoutRef.current = setTimeout(() => {
          if (iframeRef.current) {
            iframeRef.current.style.pointerEvents = 'auto';
          }
        }, 150);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  return (
    <SectionVideo>
      <Container className="video__container">
        <VideoDescription>
          FOXI ist Deine neue Software, um Abrechnung und Dokumentation so
          einfach und schnell wie möglich zu machen!
        </VideoDescription>
        <VideoContainer>
          <VideoWrapper>
            <iframe
              ref={iframeRef}
              src="https://www.youtube.com/embed/RFfgnzXPQqQ"
              title="FOXI Video Overview"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </VideoWrapper>
        </VideoContainer>
      </Container>
    </SectionVideo>
  );
};

export default Video;
